import { type UseCredentialsHanderProps } from '@capsicum/socios-core';

import { useCredentialsBaseHandler } from './useCredentialsBaseHandler';

/**
 * Hook that allows a user to perform an action if the given credential is granted.
 *
 * @param {Object} params - The parameters for the hook.
 * @param {UserCredentialsCode|UserCredentialsCode[]} params.credentialCodes - Refers to either a unique credential code or an array of credential codes to check.
 * @param {() => void} params.onCredentialGranted - Callback that is called if the credential is granted.
 *
 * @returns {Object} An object containing the handleCredential function.
 */
export const useCredentialsHandler = ({ credentialCodes, onCredentialGranted, page }: UseCredentialsHanderProps) => {
	const { onDenied, status } = useCredentialsBaseHandler({
		credentialCodes,
		onCredentialGranted,
		page
	});

	const handleCredential = () => {
		if (status === 'allowed') {
			onCredentialGranted();
		} else if (status === 'denied') {
			onDenied();
		}
	};

	return {
		handleCredential,
		status
	};
};
